import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueTheMask from 'vue-the-mask'

import { Amplify } from 'aws-amplify'
import vuetify from './plugins/vuetify'

Amplify.configure({
  Auth: {
    region: 'us-east-1',
    userPoolId: import.meta.env.VITE_AWS_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_AWS_WEB_CLIENT_ID,
    identityPoolId: import.meta.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID,
    mandatorySignIn: true,
    authenticationFlowType: 'USER_SRP_AUTH',
  },
  Analytics: {
    disabled: true,
  },
  Storage: {
    AWSS3: {
      bucket: import.meta.env.VITE_AWS_BUCKET_NAME,
      region: import.meta.env.VITE_AWS_REGION,
    },
  },
})

import App from './App.vue'
import router from './router'

// Quasar & styles imports
import { Quasar, Notify } from 'quasar'
import langPtBR from 'quasar/lang/pt-BR'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css'
import 'quasar/src/css/index.sass'
import './styles/360-styles.scss'
import './styles/360-color-palette.scss'
import './styles/typography.scss'

import '@quasar/quasar-ui-qcalendar/dist/index.css'

const pinia = createPinia()
const app = createApp(App)

app.config.globalProperties.$filters = {
  formatCurrencyValue(value = 0) {
    return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  },
}

app.use(Quasar, {
  plugins: {
    Notify,
  },
  config: {
    notify: {
      position: 'bottom',
      timeout: 2000,
      group: false,
    },
  },
  lang: langPtBR,
})
app.use(vuetify)

app.use(pinia)
app.use(router)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
app.use(VueTheMask)
app.mount('#app')
